var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plan.is_featured && _vm.plan.status == 'published')?_c('div',{staticClass:"b-plan__badge",on:{"click":function($event){return _vm.clickFeaturedLabel()}}},[_c('span',{class:'btn btn-sm ' + _vm.plan.deal.style},[_vm._v("\n            "+_vm._s(_vm.plan.deal.label)+"\n        ")])]):_c('b',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }